// extracted by mini-css-extract-plugin
export default {"actions":"UnsubmittedIncidentsTable_actions_RGw69","deleted":"UnsubmittedIncidentsTable_deleted_xjxEy"};